import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { EpcotConfig, TopNavigationConfig } from '@frontend/sports/common/client-config-data-access';
import { SportsProductService } from '@frontend/sports/host-app/sports-product/feature/sports-product-service';
import { AdaptiveLayoutService } from '@frontend/sports/layout/feature';
import { NavigationService } from '@frontend/sports/web/navigation-data-access';
import { ViewTransitionUtils } from '@frontend/vanilla/core';
import { map } from 'rxjs';

import { MainItemsComponent } from './top-navigation/main-items.component';

@Component({
    selector: 'ms-navigation',
    templateUrl: './navigation.component.html',
    imports: [NgClass, MainItemsComponent, AsyncPipe],
})
export class NavigationComponent {
    layout = inject(AdaptiveLayoutService);
    navigation = inject(NavigationService);
    epcotConfig = inject(EpcotConfig);
    sportsProductService = inject(SportsProductService);

    readonly #viewTransitionUtils = inject(ViewTransitionUtils);

    private config = inject(TopNavigationConfig);
    readonly viewModel = toSignal(
        this.config.whenReady.pipe(
            map(() => ({
                showSeparator: this.config.isDesktopNavigationCompact && !!this.config.topNavigationItems?.length,
                isDesktopNavCompact: this.config.isDesktopNavigationCompact,
            })),
        ),
    );

    isEpcotEnabled = this.epcotConfig.isEnabled;

    readonly showNavigation = toSignal(this.sportsProductService.isSportsProductActive$.pipe(this.#viewTransitionUtils.deferUntilTransitionReady()), {
        initialValue: false,
    });
}
